import { useReduxState } from 'hooks';
import { Tooltip } from 'components/common';

interface Props {
  shrink?: boolean;
}

const NoEmailAddress = ({ shrink = true }: Props) => {
  const { messages } = useReduxState();

  return (
    <Tooltip content={messages.userNoEmail}>
      <div
        className={`no-email-address ${
          shrink ? 'no-email-address-shrink' : ''
        }`}
      >
        {messages.commonNoEmailAddress}

        <style jsx>{`
          .no-email-address {
            font-size: 1.4rem;
            font-style: italic;
            font-weight: 400;
            white-space: nowrap;
          }
          .no-email-address-shrink {
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        `}</style>
      </div>
    </Tooltip>
  );
};

export default NoEmailAddress;
